import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-12 «Постачальники». Тека с этим файлом — и есть
// регистрация (`../registry.ts`). Вход — пункт «Постачальники» раздела меню
// «Довідники» (`G139`, `G142`; меню — настройка `CFG-141`, его отдаёт сервер) и
// прямой адрес `/s-12` (`?partner=…` карточки). Прочие входы раздела
// (`docs/SCREEN-MAP.md`, `S-12`, «Вхід») — из `S-02` (состояние `ПН`, «налаштувати
// умови»), `S-16` и `S-11` — появятся, когда эти поверхности будут построены.
export const meta: SurfaceMeta = {
  code: "S-12",
  // Название — слово словаря по коду (`G117`, таск 74), читается при показе.
  get title_uk() {
    return w("s12_title");
  },
  path: "/s-12",
};
